// extracted by mini-css-extract-plugin
export default {"container":"DetailedPage_container__ZIfnJ","flag":"DetailedPage_flag__v6IK2"};